import { IProviderAddress } from './providerAddress.model.interface';

export class ProviderAddress implements IProviderAddress {
  readonly streetName: string;
  readonly postalCode: string;
  readonly provinceName: string;
  readonly cityName: string;
  readonly countryName: string;

  constructor(data: IProviderAddress) {
    this.streetName = data.streetName;
    this.postalCode = data.postalCode;
    this.provinceName = data.provinceName;
    this.cityName = data.cityName;
    this.countryName = data.countryName;
  }
}
